// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"221d28c9","798":"0d5f032c","861":"11cfcca4"}[chunkId] + ".chunk.js";
};